import { delay, HttpResponse } from "msw";

export const postRephrase = async () => {
  await delay("real");
  return HttpResponse.json({
    question_id: "006f8d9e-4e4b-497e-8ed7-2cd63f846962",
    question_timestamp: "2025-04-02T21:20:07.477465Z",
    rephrased_prompt:
      "Your prompt cannot be rephrased because it's too vague or too short.  \nPlease provide more details in your prompt for better results.",
  });
};
